import React, { useState } from "react";
import { connect, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import '../../scss/pages/_login.scss';
import logo from "../../images/fhub_icon.png";
import { useHistory } from 'react-router-dom';
import {
    loadingToggleAction,
    loginAction,
} from '../../store/actions/AuthActions';


function Login(props) {
    const [email, setEmail] = useState('foodhub@gmail.com'); 
    const [errors, setErrors] = useState();
    const [password, setPassword] = useState('123456');

    const dispatch = useDispatch();
    
    function onLogin(e) {
        e.preventDefault();
     
        if (email === '' || password === '') {
            setErrors(true);
        }
        // if (error) {
        //     return;
        // }
        dispatch(loadingToggleAction(true));
        dispatch(loginAction(email, password, props.history));
    }

    const [show, setShow] = useState(false);

   const  handleShowpassword = (action) => {

        if (action == 'show') {
            setShow(true);
        } else {
            setShow(false);
        }
        
    };

    const history = useHistory();

    return (

        <div className="login">

            <div className="card mx-auto login-card">
                <div className="card-body">
                    <div className="row" style={{ position: 'relative' }}>
                        <img className='img-fluid logo-img' src={logo} />
                        <p className="text-center welcome p-0">Welcome to your restaurant portal from foodhub</p>
                        <p className="mt-3 text-center loginp ">Login to your account</p>
                        {errors && <div className="err-occur fw-bold">An error occurred.</div>}
                        {/* {props.errorMessage && (
                            <div className='text-danger'>
                                {props.errorMessage}
                            </div>
                        )}
                        {props.successMessage && (
                            <div className='bg-green-300 text-green-900 border border-green-900 p-1 my-2'>
                                {props.successMessage}
                            </div>
                        )} */}

                        <form onSubmit={onLogin}>
                            <div className="item mb-3 " style={{marginTop:'40px'}}>
                                <input type="email"  value={email}
                                    onChange={(e) => setEmail(e.target.value)} />
                                <label> E-mail</label>
                            </div>
                            <div className="item pass mb-4 mt-2">
                                <input  type={show ? 'text' : 'password'}  value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                />
                                <label className="mt-2">Password</label>
                                 
                                <div className="pass-image">

                                    {!show ? <svg onClick={() => handleShowpassword('show')} class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv disable-select" focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="VisibilityOffIcon"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"></path></svg> :

                                        <svg onClick={() => handleShowpassword('hide')} class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv disable-select" focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="VisibilityIcon"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg>}
                                 </div>
                            </div>

                            <button type="submit" className="btn text-white btn-block bg-green rounded-0 py-2 mb-4 ">
                                <strong className="fs-4"> Login</strong>
                            </button>

                        </form>

                        <Link onClick={() => history.push("/forgot-password")} className="forget-text d-flex justify-content-center fs-4 mt-1" style={{ cursor: 'pointer' }}> <b> Forgot Password?</b> </Link>


                        <div className="row m-0 mt-3">
                            <div className="col-5 p-0"><hr /></div>
                            <div className="col-2 text-center p-0"> <span className="fs-4">or</span> </div>
                            <div className="col-5 p-0"><hr /></div>
                        </div>

                        <Link onClick={() => history.push("/phone-login")} className="phone-text d-flex justify-content-center fs-4 d-flex align-items-center" style={{ cursor: 'pointer' }}>
                            <i className="mdi mdi-phone fs-2"></i> <b className="ml-2">Login with phone number</b> </Link>
                        
                        <Link onClick={() => history.push("/register")} className="phone-text d-flex justify-content-center fs-4 d-flex align-items-center" style={{ cursor: 'pointer' }}>
                            <b className="ml-2">Register</b> </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {

    return {
        errorMessage: state.auth.errorMessage,
        successMessage: state.auth.successMessage,
        showLoading: state.auth.showLoading,
    };
};
export default connect(mapStateToProps)(Login);
